import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {ResizeService} from '../../shared/resize.service';
import {MatTabNav} from '@angular/material/tabs';
import {Router} from '@angular/router';
import {EntityType} from 'smag-commons/cfg/hierarchy';
import {HierarchyEntity, HierarchyService} from '../../shared/hierarchy.service';
import {isDefined} from '../../commons/commons';
import {can} from '../../shared/permissions';
import {SmagApiService} from '../../api/smag-api.service';
import {Permission} from 'smag-commons/dto/api';
import {ControlPanelUserType, getControlPanelUserType} from '../../shared/ec-economics';


@Component({
    selector: 'app-ec-economics',
    templateUrl: './ec-economics.component.html',
    styleUrls: ['./ec-economics.component.scss']
})
export class ECEconomicsComponent implements OnInit, OnDestroy {

    private destroyed = new Subject<void>();
    @ViewChild('navBar') private navBar: MatTabNav;

    ecResource: HierarchyEntity | null; // `null` if not an energy community
    isViewable: boolean;
    controlPanelUserType: ControlPanelUserType = null;

    readonly isDefined = isDefined;
    readonly ControlPanelUserType = ControlPanelUserType;

    constructor(private readonly router: Router,
                private readonly resizeService: ResizeService,
                private readonly hierarchyService: HierarchyService,
                private readonly apiService: SmagApiService) {
        this.ecResource = null;
        this.isViewable = false;
    }

    ngOnInit() {
        // see: https://github.com/angular/components/issues/6130
        //      https://github.com/angular/components/issues/3048
        this.resizeService.observe(['content'])
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => {
                if (this.navBar) {
                    this.navBar._alignInkBarToSelectedTab();
                }
            });

        this.hierarchyService.selection.pipe(
            map(resource => resource?.type === EntityType.ENERGY_COMMUNITY ? resource : null),
            takeUntil(this.destroyed)
        ).subscribe(ecResource => {
            this.ecResource = ecResource;
            if (ecResource) {
                // permissions check
                this.isViewable = can(ecResource.permissions, Permission.READ);
            }
        });

        this.apiService.getSubjectInfo()
            .subscribe(subjectInfo => this.controlPanelUserType = getControlPanelUserType(subjectInfo));
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    get showNavbar() {
        const segments = this.router.parseUrl(this.router.url)
            .root.children.primary.segments
            .map(segment => segment.path);
        return segments[0] === 'c' && segments[1] === 'ec' && segments[2] === 'economics' &&
            (
                segments[3] === 'aggregated' ||
                segments[3] === 'redistributed' ||
                segments[3] === 'subjects-summary' ||
                segments[3] === 'totals-summary' ||
                segments[3] === 'totals-plants' ||
                segments[3] === 'member-plants' ||
                segments[3] === 'totals-community' ||
                segments[3] === 'member-pods'
            );
    }

}
